import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getOpcoOrganizationsPath = () => urlHelper('/organizations');
